// extracted by mini-css-extract-plugin
module.exports = {"publish-modal":"antd-pro-pages-home-microsite-course-manage-create-chapter-course-components-publish-modal-index-publish-modal"};